import React, { useEffect } from 'react';
import Sidenavigation from '../layout/Sidenavigation';
import Topnavigation from '../layout/Topnavigation';
import HomeContent from '../section/HelpDeskChat/Home-Content';
import { Helmet } from "react-helmet";
import HelpDeskAction from '../../../redux/Helpdesk/actions';
import CommonActions from '../../../redux/Common/actions';
import { useDispatch, useSelector } from 'react-redux';

export default function HelpDeskChat() {

    const dispatch = useDispatch();

    const { token } = useSelector(state => state.authReducer);

    const Email = token?.result?.Email;
    useEffect(() => {
        window.addEventListener("beforeunload", (event) => {
            if (Email) {
                dispatch({
                    type: HelpDeskAction.UPDATE_CHATWITH_MEMBER, payload: {
                        TypeOfUser: "Vendor",
                        ChatWith: "null",
                        Sender: Email
                    }
                });
                dispatch({ type: CommonActions.SET_CURRENT_CONVERSATION, payload: {} });
            }
        });
        return () => {
            if (Email) {
                dispatch({
                    type: HelpDeskAction.UPDATE_CHATWITH_MEMBER, payload: {
                        TypeOfUser: "Vendor",
                        ChatWith: "null",
                        Sender: Email
                    }
                });
                dispatch({ type: CommonActions.SET_CURRENT_CONVERSATION, payload: {} });
            }
        }
        //eslint-disable-next-line
    }, [Email]);

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Dashboard</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <HomeContent />
                {/* page content end  */}

            </main>

        </div>
    );
};